/**
   * 统计条件操作
   * @param operation 操作，对当前数据在符合条件时统计时进行的操作
   * @param field 判定的字段
   * @param operator 判定
   */
export default class ChargeCountDataAdapte {
  constructor(operation, field = null, operator = null, value = null) {
    this._operation = operation // 数据操作符
    this._field = field // 属性名
    this._operator = operator // 属性值判断符号
    this._value = value // 值
  }

  get operation() {
    return this._operation
  }

  set operation(value) {
    this._operation = value
  }

  get field() {
    return this._field
  }

  set field(value) {
    this._field = value
  }

  get operator() {
    return this._operator
  }

  set operator(value) {
    this._operator = value
  }

  get value() {
    return this._value
  }

  set value(value) {
    this._value = value
  }
}
